import { useEffect, useState } from 'react';

import { haptic } from '../../utils/haptic';

export const SHOWCASE_CATEGORIES = [
  { id: '', label: 'Все' },
  { id: 'marketplace', label: 'Маркетплейс' },
  { id: 'bot', label: 'Бот' },
  { id: 'site', label: 'Сайт' },
  { id: 'saas', label: 'Сервис' },
  { id: 'miniapp', label: 'Мини-приложение' },
] as const;

interface FilterBarProps {
  category: string | null | undefined;
  onCategoryChange: (category: string | null) => void;
  isFetching?: boolean;
}

const CATEGORY_ALIASES: Record<string, string> = {
  miniapp: 'miniapp',
  'mini app': 'miniapp',
  'mini-app': 'miniapp',
  'telegram mini app': 'miniapp',
  'мини-приложение': 'miniapp',
  'мини приложение': 'miniapp',
  'миниапп': 'miniapp',
  bot: 'bot',
  'telegram bot': 'bot',
  'бот': 'bot',
  site: 'site',
  website: 'site',
  landing: 'site',
  'сайт': 'site',
  'лендинг': 'site',
  saas: 'saas',
  service: 'saas',
  'сервис': 'saas',
  marketplace: 'marketplace',
  'маркетплейс': 'marketplace',
};

function normalizeCategory(value: string | null | undefined): string {
  const raw = String(value ?? '').trim().toLowerCase();
  if (!raw) return '';
  return CATEGORY_ALIASES[raw] || raw;
}

export function FilterBar({
  category,
  onCategoryChange,
  isFetching = false,
}: FilterBarProps) {
  const [blinkKey, setBlinkKey] = useState<string | null>(null);
  const normalizedCategory = normalizeCategory(category);

  useEffect(() => {
    if (!blinkKey) return;
    const t = window.setTimeout(() => setBlinkKey(null), 220);
    return () => window.clearTimeout(t);
  }, [blinkKey]);

  const handleCategoryClick = (id: string) => {
    haptic.select();
    setBlinkKey(id || 'all');
    if (id === '') {
      onCategoryChange(null);
      return;
    }
    // Toggle active chip off to return to "all".
    onCategoryChange(normalizedCategory === id ? null : id);
  };

  return (
    <div className="showcase-filter-bar">
      <div className="showcase-filter-bar__scroll">
        <div className="showcase-filter-bar__group">
          {SHOWCASE_CATEGORIES.map(({ id, label }) => {
            const isActive = id === '' ? normalizedCategory === '' : normalizedCategory === id;
            const isBlink = blinkKey === (id || 'all');
            return (
              <button
                key={id || 'all'}
                type="button"
                className={`showcase-chip ${isActive ? 'showcase-chip--active' : ''} ${isActive && isFetching ? 'showcase-chip--busy' : ''} ${isBlink ? 'showcase-chip--blink' : ''}`}
                aria-pressed={isActive}
                onClick={() => handleCategoryClick(id)}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
